import React, {Component} from 'react';
import { observer } from "mobx-react";
import { IconeCarregar } from '../../components/Icones';

@observer
export default class LoadingImage extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className={`loading-container ${this.props.className ? this.props.className : ""}`}>
                <IconeCarregar tamanho="2x"/>
            </div>

        );
            
    }
}


// WEBPACK FOOTER //
// ./src/modules/comum/loading/components/LoadingImage.js